import axios from "axios";
import { api_url } from "./Environment";

const CONTACT_US = `${api_url}api/contact-us`;

export const submitContactUs = async (payload) => {
  try {
    const response = await axios.post(CONTACT_US, payload);
    return response.data;
  } catch (error) {
    throw error?.response?.data || error.message;
  }
};
